const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ProductCompareCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.1,
              spacing: 15,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3,
              spacing: 15,
            },
          },
          '(min-width: 1441px)': {
            slides: {
              perView: 4,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-compare-carousel')) {
  customElements.define('product-compare-carousel', ProductCompareCarousel)
}
